// ForgotPassword.js

import React, { useEffect, useState } from 'react';
import { useLocation,useNavigate } from 'react-router-dom';
import { Alert } from "react-bootstrap";
import { BASE_URL } from "../utils/config";
import {useParams} from 'react-router-dom';
import background from "../images/background2.jpg";
import LOGOJI from "../images/RKLOGO.png";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
} from "@mui/material";


const ForgotPasswordLINK = () => {
  const location = useLocation();
  const navigate = useNavigate();
  console.log('Location:', location); 
  const [show,setShow]=useState('')
   const [errorDialog,setErrorDialog]=useState(false);
    const [errorMessage,setErrorMessage]=useState("");
  const [changepasswordData, setChangePasswordData] = useState({
    newpassword: '',
    confirmpassword: '',
  });
  const passwordRegex =
    /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+[\]{};:<>?]{8,}$/;
  const [showInvalidNewPasswordAlert, setShowInvalidNewPasswordAlert] = useState(false);
  const [showInvalidConfirmPasswordAlert, setShowInvalidConfirmPasswordAlert] = useState(false);
  const [showInvalidMatchPasswordAlert, setShowInvalidMatchPasswordAlert] = useState(false);
  const param = useParams();
  let count = 0;
  


useEffect(() => {
  console.log("params",param)
  verifyEmailUrl(param);
  count += 1
}, []);


//  this function is use to verify mail 
const verifyEmailUrl = async (param) => {
  
    if(count === 0){
    try {
      console.log("ID:", param.id, "Token:", param.token)
 
      await fetch(`${BASE_URL}/forgetpassword/${param.id}/verify/${param.token}`, {
          method: 'POST',
      })
          .then(res => res.json())
          .then(res => {
              console.log('res', res);
              if(res.success === true){
                setShow('change')
              }
              if(res.success === false){
                if(res.status === 404){
                    setShow('forgotpassword')
                }
              }

              
            //   setValidUrl(true);
          });
  } catch (error) {
      console.log(error);
      setErrorMessage(`Error: ${error.message}`);
      setErrorDialog(true)
      setTimeout(() => {
        setErrorDialog(false)
        setErrorMessage("")
        }, 1700);
  }
    }
};





//  this fucntion is used to handle values change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setChangePasswordData({
      ...changepasswordData,
      [name]: value,
    });
  };


//  this function is used to handle chnage password
  const handleChangepasswordSubmit = (e) => {
    try{
    e.preventDefault();
    console.log("inside change password")

     if (!passwordRegex.test(changepasswordData.newpassword)) {
      setShowInvalidNewPasswordAlert(true);
      setTimeout(() => {
        setShowInvalidNewPasswordAlert(false);
      }, 5000);
    }
    else if (!passwordRegex.test(changepasswordData.confirmpassword)) {
      setShowInvalidConfirmPasswordAlert(true);
      setTimeout(() => {
        setShowInvalidConfirmPasswordAlert(false);
      }, 5000);
    }
    else if (changepasswordData.newpassword != changepasswordData.confirmpassword) {
      console.log("password and confirm password doesn't match");
      setShowInvalidMatchPasswordAlert(true);
      setTimeout(() => {
        setShowInvalidMatchPasswordAlert(false);
      }, 5000);
    }else{
      
 
      let body = JSON.stringify({new_password: changepasswordData.newpassword });
      fetch(`${BASE_URL}/forgetpassword/${param.id}`, {
        method: "put",
        body,
        headers: {
          "Content-Type": "application/json",
        },
      }).then((res) => res.json())
      .then((res) => {
        console.log("res", res);
        if(res.success === true){
          navigate('/login');
        }
        else{
        
          setErrorMessage(`Error: ${res.message}`);
          setErrorDialog(true)
          setTimeout(() => {
            setErrorDialog(false)
            setErrorMessage("")
            }, 1700);
        }
      }).catch((error)=>{
        setErrorMessage(`Error: ${error.message}`);
        setErrorDialog(true)
        setTimeout(() => {
          setErrorDialog(false)
          setErrorMessage("")
          }, 1700);
      })
    }
  }catch(error){
    setErrorMessage(`Error: ${error.message}`);
    setErrorDialog(true)
    setTimeout(() => {
      setErrorDialog(false)
      setErrorMessage("")
      }, 1700);
  }
  }



  return (
    <div className='forgot-password-container' style={{
     
      backgroundImage: 'linear-gradient(to bottom,  #ffffff, #0074d9)',
      height: '100vh',
      position: 'relative',
    }}>

      {show === 'forgotpassword' ?
        <div className='forgot-password-form'>
          <h2>404 Page Not found.</h2>
        </div>
        :
        <div className="newlogin">
    <img src={background} alt=""  style={{width:"550px", marginLeft:"15%"}}/>
      <div className="box" style={{marginLeft:"11%"}}>
        <span className="borderLine"></span>
        <div className='forgot-password-form'>
        
          <form onSubmit={handleChangepasswordSubmit}>
          <a href="https://www.iamrakeshbansal.com/" style={{ position: "absolute", top: "-2px", left: "20px", marginLeft: "32%", width: '100px' }}>
        <img src={LOGOJI} alt="RNR Logo" className="LOGO" />
      </a>
          <h4>Change Password</h4>
            <div className='form-group'>
              <div className='form-group col'>
                <label htmlFor='New Password' >
                  New Password
                  <span className='astrik-mark'>*</span>
                </label>
                {showInvalidNewPasswordAlert && (
                  <Alert
                    variant="danger"
                    onClose={() => setShowInvalidNewPasswordAlert(false)}
                    dismissible
                  >
                    Please enter a valid password. Passwords must be at least
                    8 characters long and contain at least one letter, one
                    digit, and may include special characters.
                  </Alert>
                )}
                {showInvalidMatchPasswordAlert && (
                  <Alert
                    variant="danger"
                    onClose={() => setShowInvalidMatchPasswordAlert(false)}
                    dismissible
                  >
                    Password and confirm password do not match. Please make
                    sure they are the same.
                  </Alert>
                )}
                <input className='form-control form-control-lg' type='password' name='newpassword' id='newpassword' onChange={handleChange} required />
              </div>
              <div className='form-group col'>
                <label htmlFor='Confirm Password'>
                  Confirm Password
                  <span className='astrik-mark'>*</span>
                </label>
                {showInvalidConfirmPasswordAlert && (
                  <Alert
                    variant="danger"
                    onClose={() => setShowInvalidConfirmPasswordAlert(false)}
                    dismissible
                  >
                    Please enter a valid password. Passwords must be at least
                    8 characters long and contain at least one letter, one
                    digit, and may include special characters.
                  </Alert>
                )}
                <input className='form-control form-control-lg' type='password' name='confirmpassword' id='confirmpassword' onChange={handleChange} required />
              </div>
            </div>

            <button type='submit' className='btn btn-primary'>
              Submit
            </button>
          </form>
        </div>
        </div>
        </div>
      }

         {/*Error Message Dialog */}
                  <Dialog
              open={errorDialog}
              onClose={()=>{setErrorDialog(false)}}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle  id="alert-dialog-title">
              <h4 style={{ color: "red" }}>Failure</h4>
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                 
                       
                  {errorMessage}
                   
                
                </DialogContentText>
              </DialogContent>
             
                  </Dialog>
    </div>
  );
};

export default ForgotPasswordLINK;
